<template>
    <form
        class="flex flex-col gap-6"
        @submit.prevent="handleCreate"
    >
        <CoreStringInput
            id="role_name"
            ref="roleNameInput"
            placeholder="§permissions.ui_set_new_role_name"
            name="role_name"
            :fullWidth="true"
            v-model="roleName"
            :disabled="settingsStore.saving_role"
            required
            :aria-describedby="roleName.length === 0 ? 'role-name-error' : null"
        />

        <CoreCheckbox
            id="internal_role"
            label="§ui_button.checkbox_internal"
            v-model="isInternal"
            :disabled="settingsStore.saving_role"
        />

        <div
            class="flex gap-2"
            role="group"
            aria-label="Form actions"
        >
            <CoreButton
                label="§ui_button.save"
                type="submit"
                :loading="settingsStore.saving_role"
                :disabled="!isValid || settingsStore.saving_role"
                icon="pi-save"
            />

            <CoreButton
                label="§ui_button.cancel"
                type="button"
                variant="tertiary"
                @click="handleClose"
                :disabled="settingsStore.saving_role"
                icon="pi-times"
            />
        </div>
    </form>
</template>

<script>
import { useSettingsStore } from '@/stores/settings'
import { useModalStore } from '@/stores/modal'
import CoreStringInput from '@/components/core/CoreStringInput.vue'
import CoreButton from '@/components/core/CoreButton.vue'
import CoreCheckbox from '@/components/core/CoreCheckbox.vue'

export default {
    name: 'CreateRoleModal',

    components: {
        CoreStringInput,
        CoreButton,
        CoreCheckbox,
    },

    data() {
        return {
            settingsStore: useSettingsStore(),
            modalStore: useModalStore(),
            roleName: '',
            isInternal: false,
        }
    },

    computed: {
        isValid() {
            return this.roleName.trim().length > 0
        },
    },

    mounted() {
        setTimeout(() => {
            if (this.$refs.roleNameInput && this.$refs.roleNameInput.$el) {
                this.$refs.roleNameInput.$el.firstChild.focus()
            } else if (this.$refs.roleNameInput && this.$refs.roleNameInput.focus) {
                this.$refs.roleNameInput.focus()
            }
        }, 300)
    },

    methods: {
        async handleCreate() {
            await this.settingsStore.createRole({
                name: this.roleName.trim(),
                is_internal: this.isInternal,
            })
            this.handleClose()
        },

        handleClose() {
            this.modalStore.setClose()
        },
    },
}
</script>
